import { useRef, useEffect, useLayoutEffect } from 'react'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import Box from '@mui/material/Box'
import { SxProps } from '@mui/system'
import { Theme } from '@mui/material/styles'
import numeral from 'numeral'

am4core.useTheme(am4themes_animated)

type PieChartProps = {
    chartName: string
    chartData: Array<any>
    dataFieldsValue: string
    dataFieldsCategory?: string
    sxProps?: SxProps<Theme>
    legend?: {
        position: am4charts.LegendPosition
    }
    responsive?: boolean
    titleText?: string
    titleTextSize?: number
    onClickChart?: (properties?: string) => void
}
const PieChart = (props: PieChartProps) => {
    const { responsive = false } = props
    let refChart = useRef<am4charts.PieChart>()

    const createChart = () => {
        let chart = am4core.create(props.chartName, am4charts.PieChart)
        refChart.current = chart

        const chartDataSum = props.chartData
            .map((item) => item.sum)
            .reduce((a, b) => a + b, 0)
            .toString()

        chart.radius = am4core.percent(80)
        chart.data = props.chartData
        chart.logo.disabled = true
        chart.innerRadius = am4core.percent(50)
        chart.responsive.enabled = responsive

        // Add a legend
        if (props.legend) {
            chart.legend = new am4charts.Legend()
            chart.legend.position = props?.legend.position ?? 'bottom'
            chart.legend.useDefaultMarker = true
            chart.legend.labels.template.text = '{category}'
            chart.legend.itemContainers.template.clickable = false
            chart.legend.itemContainers.template.focusable = false
            chart.legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default
            let markerTemplate = chart.legend.markers.template
            markerTemplate.fontSize = 14
            markerTemplate.width = 10
            markerTemplate.height = 10
        }

        if (props.titleText) {
            let title = chart.titles.create()
            title.text = props.titleText
            title.fontSize = props?.titleTextSize ?? 14
            title.marginTop = 15
            title.marginBottom = 3
            title.fontWeight = 'bold'
            title.wrap = true
        }

        // Create pie series
        let pieSeries = chart.series.push(new am4charts.PieSeries())
        pieSeries.dataFields.value = props.dataFieldsValue
        pieSeries.dataFields.category = props.dataFieldsCategory
        // pieSeries.labels.template.disabled = false
        pieSeries.ticks.template.disabled = false
        pieSeries.labels.template.text = '[bold]{value}'
        pieSeries.labels.template.fontSize = 12
        // Set up slices
        pieSeries.slices.template.tooltipText = ''
        pieSeries.slices.template.alwaysShowTooltip = true
        pieSeries.slices.template.propertyFields.fill = 'color'

        // pieSeries.colors.list = [
        //     am4core.color("#F15F31"),
        //     am4core.color("#F1BC31"),
        //     am4core.color("#679A2E")
        // ]

        pieSeries.slices.template.events.on('hit', (ev) => {
            let properties = ev?.target?.dataItem?.properties
            props?.onClickChart?.(properties?.['category'])
        })

        pieSeries.legendSettings.valueText = '{valueY.close}' // disabled %

        let label = pieSeries.createChild(am4core.Label)
        label.text = numeral(chartDataSum).format('0,0')
        // label.text = "{values.value.sum}"
        label.horizontalCenter = 'middle'
        label.verticalCenter = 'middle'
        label.fontSize = 18
    }

    useLayoutEffect(() => {
        createChart()
        return () => {
            refChart.current?.dispose()
        }
    }, [props.chartData])

    return (
        <>
            <Box id={props.chartName} sx={props.sxProps}></Box>
            <div id="legend"></div>
        </>
    )
}

export default PieChart
